export default __webpack_public_path__ + "static/media/footer__logo.ea0c4813.svg";